import { Column, Table } from "@tanstack/react-table";
import CheckboxGroup from "./CheckboxGroup";
import Range from "./Range";

import { useMemo } from "react";
import { match } from "ts-pattern";
import TextFilter from "./Text";
import ProductFilter from "./Product";

type FilterType = "calc" | "text" | "select" | "selects" | "range" | "product";

export default function FliterContent<T>({
  table,
  column,
}: {
  table: Table<T>;
  column: Column<T, unknown>;
}) {
  const firstValueType = useMemo(() => {
    return column.columnDef.filterFn as FilterType;
  }, [column.columnDef.filterFn]);

  return (
    <div className="relative">
      {match(firstValueType)
        .with("calc", () => <Range column={column} />)
        .with("range", () => <Range column={column} />)
        .with("select", () => <CheckboxGroup column={column} />)
        .with("selects", () => <CheckboxGroup column={column} />)
        .with("text", () => <TextFilter column={column} />)
        .with("product", () => <ProductFilter column={column} />)
        .otherwise(() => null)}
    </div>
  );
}
